<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6">
        <div class="grid_header">
          <div></div>
          <div class="text-center ma-4">
            <div class="text_font">ฟอร์มส่งคืน/เปลี่ยนสินค้า</div>
            <div>บริษัท ฟาร์มาแคร์ พลัส จำกัด</div>
          </div>
          <div class="ma-4">
            <div class="grid_flex justify-end">
              <div class="mr-2">เลขที่เอกสาร :</div>
              <div>{{ data_set.doc_no }}</div>
            </div>
            <!-- <div class="grid_flex justify-end">
              <div class="mr-2">TF :</div>
              <div>{{ data_set.tf_no }}</div>
            </div> -->
          </div>
        </div>
        <div class="pa-6">
          <div class="grid_list">
            <div>บริษัท เอ็ฟ บี ฟาร์มา</div>
            <div class="grid_flex">
              <div class="mr-5">ผู้แทน</div>
              <div>{{ data_set.representative }}</div>
            </div>
          </div>
          <div class="grid_list mt-2">
            <div class="grid_flex">
              <div class="mr-5">วันที่แจ้งคืนสินค้า</div>
              <div>{{ return_date }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5">วันที่ส่งสินค้า</div>
              <div>{{ send_date }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5">ผู้แจ้งคืน</div>
              <div>{{ user_list.name }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5">แจ้งโดย</div>
              <div v-if="data_set.notified_by === 0">Line.</div>
              <div v-else-if="data_set.notified_by === 1">โทร</div>
              <div v-else-if="data_set.notified_by === 2">ต่อหน้า</div>
            </div>
          </div>
          <div class="grid_list mt-2">
            <div class="grid_flex">
              <div class="mr-2">สาเหตุที่ส่งคืน</div>
              <div v-if="data_set.cause_return === 0">ของมาผิด</div>
              <div v-else-if="data_set.cause_return === 1">ของไม่ได้สั่ง</div>
              <div v-else-if="data_set.cause_return === 2">ชำรุด</div>
              <div v-else-if="data_set.cause_return === 3">{{ data_set.cause_text }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5 red--text">วิธีการแก้ไข</div>
              <div v-if="data_set.issue_select === 0">ทำใบ C/N</div>
              <div v-else-if="data_set.issue_select === 1">คืนเป็นสินค้าเดิม</div>
              <div v-else-if="data_set.issue_select === 2">{{ data_set.note_issue }}</div>
              <div v-else-if="data_set.issue_select === 3">คืนไปเลยเพราะส่งผิด</div>
            </div>
          </div>
        </div>
        <div class="ma-2">
          <v-divider/>
          <v-data-table :headers="headers" :items="doc_lists" key="index" :items-per-page="perPage" mobile-breakpoint="0" hide-default-footer>
            <template slot="item" slot-scope="dataDetails">
              <tr>
                <td>{{ dataDetails.index + 1 }}</td>
                <td>{{ dataDetails.item.product_name }}</td>
                <td>{{ dataDetails.item.lot_no }}</td>
                <td>{{ format_number(dataDetails.item.qty) }}</td>
                <td>{{ dataDetails.item.unit_name }}</td>
                <td>
                  <div class="ma-4">
                    <div v-if="dataDetails.item.reason !== null">{{ dataDetails.item.reason }}</div>
                    <div v-else>-</div>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-divider/>
        </div>
        <div class="pa-6">
          <document_user :user="data_set.user_name_change" :create_time="data_set.create_at" :status="data_set.status" :update_user="data_set.user_name_success" time_update=""/>
        </div>
        <div class="pl-6 pb-6">
          <div style="color: #114fd7">การตอบรับจากซัพพลายเออร์</div>
          <div class="grid_half">
            <div class="grid_half">
              <div class="grid_flex">
                <div class="mr-2">เลขที่เอกสาร :</div>
                <div>{{ data_set.doc_from_supplier }}</div>
              </div>
              <div class="grid_flex">
                <div class="mr-2">วันที่</div>
                <div v-if="data_set.receipt_date !== null">{{ receipt_date }}</div>
                <div v-else>-</div>
              </div>
            </div>
          </div>
          <div class="grid_half mt-6">
            <div class="grid_flex">
              <div class="mr-2">หมายเหตุ</div>
            <div v-if="data_set.note !== null">{{ data_set.note }}</div>
            <div v-else>...................................................................................................</div>
            </div>
          </div>
        </div>
        <div class="pt-3 pb-5 text-center grid_btn">
          <v-btn x-large class="grad-grey-bg white--text mr-4 ml-4" @click="print_document(data_set.doc_no)" style="font-size: 18px">พิมพ์เอกสาร</v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>


<script>
import document_user from "@/components/admin/document_stock/header_document/document_user";
import {HTTP} from "@/axios";
import {diffDateTH, formatNumber} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Document_reduce_details",
  components: {
    document_user
  },
  data() {
    return {
      loading_page: false,
      modal_return_product: false,
      date: '',
      menu_date: false,
      perPage: -1,
      start_date: null,
      headers: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '100px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'รหัสล็อต',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '120px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '120px',
        },
        {
          text: 'หมายเหตุ',
          value: 'reason',
          fixed: true,
          width: '250px',
        },
      ],
      data_set: [],
      send_date: '',
      return_date: '',
      receipt_date: '',
      doc_lists: [],
      user_list: [],
    }
  },
  methods:  {
    format_number: function (value) {
      return formatNumber(value)
    },
    diffDateThai: function(value) {
      return diffDateTH(value)
    },
    get_all() {
      this.loading_page = true
      HTTP.post('/returnproductdocs/detail', {
        return_doc_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.data_set = res.data.doc
          this.send_date = this.diffDateThai(res.data.doc.send_date)
          this.return_date = this.diffDateThai(res.data.doc.return_date)
          this.receipt_date = this.diffDateThai(res.data.doc.receipt_date)
          this.doc_lists = res.data.doc_lists
          this.user_list = res.data.users.find((data) => {
            return data.id === this.data_set.return_user_id
          })
        }
      })
    },
    print_document(doc_no) {
      window.open('https://www.pharmacare-plus.com/returnpdf/'+ doc_no, '_blank')
    }
  },
  mounted() {
    this.get_all()
  }
}
</script>

<style scoped>
.text_font {
  font-size: 26px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.grid_header {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}
.grid_list {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
@media only screen and (max-width: 1024px) {
  .grid_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 700px) {
  .grid_header {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_btn {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
